module.exports = __webpack_public_path__ + "img/icaon_tixian_01@2x.0fd68b15.png";